import {
  useState
} from "react";

import {
  useNavigate
} from "react-router-dom";

import api from "../../api";

function PersonnelForm() {

  const navigate =
    useNavigate();

  const [form, setForm] =
    useState({
      nom: "",
      prenom: "",
      post_nom: "",
      telephone: "",
      fonction: "",
      salaire_base: ""
    });

  const [loading, setLoading] =
    useState(false);

  // =====================
  // CHANGE
  // =====================

  const handleChange =
    (e) => {

      const {
        name,
        value
      } = e.target;

      if (
        name ===
        "telephone"
      ) {

        let cleaned =
          value.replace(
            /[^0-9+]/g,
            ""
          );

        if (
          cleaned.includes(
            "+"
          )
        ) {

          cleaned =
            "+" +
            cleaned.replace(
              /\+/g,
              ""
            );
        }

        setForm({
          ...form,
          [name]:
            cleaned
        });

        return;
      }

      setForm({
        ...form,
        [name]: value
      });
    };

  // =====================
  // SUBMIT
  // =====================

  const handleSubmit =
    async () => {

      if (
        !window.confirm(
          "Confirmer ?"
        )
      ) {
        return;
      }

      setLoading(true);

      try {

        await api.post(
          "/personnel",
          form
        );

        navigate(
          "/personnel"
        );

      } catch (err) {

        console.error(err);

        alert(
          "Erreur ajout personnel"
        );

      }

      setLoading(false);
    };

  // =====================
  // RENDER
  // =====================

  return (
    <div className="min-h-[100dvh] bg-gray-100 px-3 md:px-6 py-4 md:py-6">

      <div className="max-w-4xl mx-auto">

        {/* NAV */}
        <div className="flex flex-col md:flex-row justify-between md:items-center gap-3 mb-6">

          <button
            onClick={() =>
              navigate(
                "/dashboard"
              )
            }
            className="bg-gray-200 hover:bg-gray-300 transition px-4 py-3 rounded-xl"
          >
            ← Dashboard
          </button>

          <button
            onClick={() =>
              navigate(
                "/personnel"
              )
            }
            className="bg-blue-600 hover:bg-blue-700 transition text-white px-4 py-3 rounded-xl"
          >
            Liste personnel →
          </button>

        </div>

        {/* CARD */}
        <div className="bg-white rounded-2xl shadow-lg p-4 md:p-8">

          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center">
            Ajouter personnel
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            <div>

              <label className="text-sm text-gray-600">
                Nom
              </label>

              <input
                name="nom"
                placeholder="Ex: Tshishiku"
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 w-full outline-none focus:ring-2 focus:ring-green-400"
              />

            </div>

            <div>

              <label className="text-sm text-gray-600">
                Post-nom
              </label>

              <input
                name="post_nom"
                placeholder="Ex: Mukendi"
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 w-full outline-none focus:ring-2 focus:ring-green-400"
              />

            </div>

            <div>

              <label className="text-sm text-gray-600">
                Prénom
              </label>

              <input
                name="prenom"
                placeholder="Ex: Sylvain"
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 w-full outline-none focus:ring-2 focus:ring-green-400"
              />

            </div>

            <div>

              <label className="text-sm text-gray-600">
                Téléphone
              </label>

              <input
                name="telephone"
                placeholder="+243XXXXXXXXX"
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 w-full outline-none focus:ring-2 focus:ring-green-400"
              />

            </div>

            <div>

              <label className="text-sm text-gray-600">
                Fonction
              </label>

              <input
                name="fonction"
                placeholder="Ex: Réceptionniste"
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 w-full outline-none focus:ring-2 focus:ring-green-400"
              />

            </div>

            <div>

              <label className="text-sm text-gray-600">
                Salaire
              </label>

              <input
                name="salaire_base"
                type="number"
                placeholder="Ex: 200"
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 w-full outline-none focus:ring-2 focus:ring-green-400"
              />

            </div>

          </div>

          <div className="flex flex-col md:flex-row gap-3 mt-6">

            <button
              onClick={() =>
                navigate(
                  "/personnel"
                )
              }
              className="flex-1 bg-gray-200 hover:bg-gray-300 transition py-3 rounded-xl font-semibold"
            >
              Annuler
            </button>

            <button
              onClick={
                handleSubmit
              }
              disabled={loading}
              className="flex-1 bg-green-600 hover:bg-green-700 transition text-white py-3 rounded-xl font-semibold disabled:opacity-50"
            >
              {loading
                ? "Ajout..."
                : "Ajouter"}
            </button>

          </div>

        </div>

      </div>

    </div>
  );
}

export default PersonnelForm;